import {
  CurrencyAllocationWidget,
  EventsCalendarWidget,
  FavouritesWatchlistWidget,
  NextEventsWidget,
  NotificationsWidget,
  ProductsNearExpiryWidget,
  TopUnderlyingExposureWidget,
} from '../../components/dashboardWidgets/HomeWidgetAdapters';
import {
  IssuerRankingNotionalWidget,
  IssuerRankingProductsWidget,
} from '../../components/dashboardWidgets/IssuerRankingWidgets';
import {
  DashboardWidgetDefinition,
  DashboardWidgetId,
  DASHBOARD_WIDGET_IDS,
  isDashboardWidgetId,
} from './types';

/**
 * Predefined Home widget catalog. Unknown ids are not in this map
 * and cannot be added to a layout.
 */
export const DASHBOARD_WIDGET_REGISTRY: Record<DashboardWidgetId, DashboardWidgetDefinition> = {
  issuer_ranking_notional: {
    id: 'issuer_ranking_notional',
    title: 'Issuer Ranking by Notional',
    defaultWidthSpan: 1,
    Component: IssuerRankingNotionalWidget,
  },
  issuer_ranking_products: {
    id: 'issuer_ranking_products',
    title: 'Issuer Ranking by Number of Products',
    defaultWidthSpan: 1,
    Component: IssuerRankingProductsWidget,
  },
  currency_allocation: {
    id: 'currency_allocation',
    title: 'Currency allocation',
    defaultWidthSpan: 1,
    Component: CurrencyAllocationWidget,
  },
  products_near_expiry: {
    id: 'products_near_expiry',
    title: 'Products near expiry',
    defaultWidthSpan: 1,
    Component: ProductsNearExpiryWidget,
  },
  top_underlying_exposure: {
    id: 'top_underlying_exposure',
    title: 'Top 10 Underlying Exposure',
    defaultWidthSpan: 2,
    Component: TopUnderlyingExposureWidget,
  },
  favourites_watchlist: {
    id: 'favourites_watchlist',
    title: 'Watchlist',
    defaultWidthSpan: 1,
    Component: FavouritesWatchlistWidget,
  },
  events_calendar: {
    id: 'events_calendar',
    title: 'Events calendar',
    defaultWidthSpan: 1,
    Component: EventsCalendarWidget,
  },
  next_events: {
    id: 'next_events',
    title: 'Next events',
    defaultWidthSpan: 1,
    Component: NextEventsWidget,
  },
  notifications: {
    id: 'notifications',
    title: 'Notifications',
    defaultWidthSpan: 1,
    Component: NotificationsWidget,
  },
};

export const DASHBOARD_WIDGET_CATALOG: readonly DashboardWidgetDefinition[] =
  DASHBOARD_WIDGET_IDS.map((id) => DASHBOARD_WIDGET_REGISTRY[id]);

export const getDashboardWidget = (id: string): DashboardWidgetDefinition | undefined => {
  if (!isDashboardWidgetId(id)) {
    return undefined;
  }
  return DASHBOARD_WIDGET_REGISTRY[id];
};
